import { initializeLazyLoader } from '~/controllers/loader/lazy_loader'
initializeLazyLoader()
